import styled from "styled-components";

export const Panel = styled.div`
  padding: 16px;
  background: #fff;
`;

export const TabContent = styled.div`
  background: #fff;
  transition: height 0.3s ease-in-out;
  overflow-y: auto;
  min-height: 450px;
  max-height: 500px;
`;

export const TabContainer = styled.div`
  background: #fff;
  border-radius: inherit;

  & > .fade-forward-enter {
    opacity: 0;
    transform: translateX(20%);
  }
  & > .fade-forward-exit {
    opacity: 1;
    transform: translate(0, 0);
  }
  & > .fade-forward-enter-active {
    opacity: 1;
    transform: translate(0, 0);
  }
  & > .fade-forward-exit-active {
    opacity: 0;
    transform: translateX(-20%);
  }
  & > .fade-backward-enter {
    opacity: 0;
    transform: translateX(-20%);
  }
  & > .fade-backward-exit {
    opacity: 1;
    transform: translate(0, 0);
  }
  & > .fade-backward-enter-active {
    opacity: 1;
    transform: translate(0, 0);
  }
  & > .fade-backward-exit-active {
    opacity: 0;
    transform: translateX(20%);
  }
  & > .fade-forward-enter-active,
  & > .fade-forward-exit-active,
  & > .fade-backward-enter-active,
  & > .fade-backward-exit-active {
    transition: opacity 0.14s, transform 0.14s;
  }

  ${({ styles }) => styles};
`;

export const TabHeader = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
  background-color: rgb(239, 241, 252);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;

  svg {
    width: 25px;
    height: 25px;
    background-color: #dce0fc;
    border-radius: 50%;
    padding: 5px;
    margin: 4px 4px 0 auto;
    transition: transform 0.3s ease-in-out;
    &:hover {
      transform: scale(1.05);
    }
  }
`;

export const TabList = styled.div`
  display: flex;
  border-bottom: 1px solid #abb4f4;
  max-width: 100%;
  flex-wrap: nowrap;

  [role="tab"] {
    border: none;
    color: #7a89f4;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 400;
    background-color: #eff1fc;
    padding: ${({ icon }) => (icon ? "0 1rem 12px" : "12px 1rem")};
    cursor: pointer;
    text-align: center;
    flex: 1 0 auto;
    transition: color 0.2s;

    &[aria-selected="true"] {
      cursor: auto;
      color: #1e1f43;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`;

export const TabIndicator = styled.div`
  position: absolute;
  height: 3px;
  background-color: #1e22ff;
  bottom: -1px;
  left: 0;
  width: ${({ tabCount }) => 100 / tabCount}%;
  transform: translateX(${({ activeIndex }) => activeIndex * 100}%);
  transition: transform 0.3s ease-in-out;
`;
